import { LOADING_CITING_ARTICLES, RECEIVED_CITING_ARTICLES, RECEIVED_CITING_ARTICLES_FAILED } from '../types';
import { createFetcher } from '../utils';
import { identificationType } from '../../constants';

export default {
  urlFormatter: {
    [identificationType.pii]: ({ pii, token }) => `/enhancements/article/pii/${pii}/citedby?token=${token}`,
    [identificationType.doi]: ({ doi, token }) => `/enhancements/article/doi/${doi}/citedby?token=${token}`,
  },
  fetch: createFetcher(
    LOADING_CITING_ARTICLES, RECEIVED_CITING_ARTICLES, RECEIVED_CITING_ARTICLES_FAILED,
  ),
};
